/**
 * Drag overlay for reordering a whole preset group by header grip
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { GripVertical } from 'lucide-react';

export interface PresetGroupDragOverlayProps {
  label: string;
  templateDropCount: number;
  presetCount: number;
}

export const PresetGroupDragOverlay: FC<PresetGroupDragOverlayProps> = ({
  label,
  templateDropCount,
  presetCount,
}) => (
  <div className="pointer-events-none flex w-full max-w-4xl items-stretch rounded-lg border border-border bg-background shadow-xl">
    <div className="flex shrink-0 cursor-grabbing items-center px-2 text-muted-foreground">
      <GripVertical className="h-4 w-4" />
    </div>
    <div className="min-w-0 flex-1 py-2 pr-3">
      <p className="text-sm font-medium text-foreground">{label}</p>
      <p className="mt-0.5 text-xs tabular-nums text-muted-foreground">
        {templateDropCount} drop{templateDropCount !== 1 ? 's' : ''}
        <span className="mx-1">·</span>
        {presetCount} preset{presetCount !== 1 ? 's' : ''}
      </p>
    </div>
  </div>
);
